import { memo } from "react";
import TreemapCellLabel from "./TreemapCellLabel";
import type { HierarchyRectangularNode } from "d3-hierarchy";
import type { EnrichedTradeDataItem } from "@atlas-int/data/types";
import type { UIView, ColorBy } from "@atlas-int/data";

type TreemapLeaf = HierarchyRectangularNode<EnrichedTradeDataItem>;

interface TreemapLabelsProps {
  leaves: TreemapLeaf[] | undefined;
  exporter?: string;
  importer?: string;
  totalSum: number | undefined;
  servicesWidth?: number;
  nonServices?: boolean;
  view: UIView;
  colorBy: ColorBy;
  locationDetailLevel: string;
}

const TreemapLabels = ({
  leaves,
  exporter,
  importer,
  totalSum,
  servicesWidth,
  nonServices,
  view,
  colorBy,
  locationDetailLevel,
}: TreemapLabelsProps) => {
  if (!leaves) return null;

  return (
    <>
      {leaves.map((leaf: TreemapLeaf, i: number) => {
        // Use leaf.id if available, otherwise fall back to leaf.data.productId or leaf.data.id, and finally index
        let cellLabelKey = `label_${exporter}_${importer}_${i}_${leaf.id || leaf.data?.productId || leaf.data?.id || i}`;
        return (
          <TreemapCellLabel
            key={cellLabelKey}
            leaf={leaf}
            totalSum={totalSum}
            servicesWidth={servicesWidth}
            nonServices={nonServices}
            view={view}
            colorBy={colorBy}
            locationDetailLevel={locationDetailLevel}
          />
        );
      })}
    </>
  );
};

export default memo(TreemapLabels);
